import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";

import { StringValue } from "./StringValue";
import { StringMap } from "./StringMap";
import { StringArray } from "./StringArray";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Tower Player">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StringValue
          label={"Selected Tower"}
          value={task.taskstatusdetail.selectedtower}
          valueParser={(v) => {
            if (v === "sagetower") {
              return <div>Sage Tower(C1)</div>;
            } else if (v === "sagetower") {
              return <div>Lake-town Tower</div>;
            }
          }}
        />
        <StringValue
          label={"Open Claimed Items?"}
          value={task.taskstatusdetail.openwonitems}
          valueParser={(v) => <div>{`${v === true ? "Yes" : "No"}`}</div>}
        />
        <StringMap
          label={"Selected Events"}
          valueMap={task.taskstatusdetail.towerplayconfig}
          valueParser={(k, v) => `${k}.${v.event.name}(${v.quantity})`}
        />
        <StringValue
          label={"Currently Running Event"}
          value={task.taskstatusdetail.currentevent}
        />
        <StatusSection task={task} />
        <StringArray
          label={"Items Won:"}
          array={task.taskstatusdetail.itemswon}
          valueParser={(item) => `${item.itemname} : ${item.itemcount}`}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
